<template>
  <div class="MobileFilterDialog">
    <div>
      <el-dialog :visible.sync="filter_dialog_visible" :before-close="handleClose">
        <div class="filter-header">
          <div>{{ filter_title }}</div>
        </div>

        <div class="filter-section-title">
          <span class="border-bottom relative">Filters</span>
          <span class="input-label-gray cursor-pointer" @click="resetFilter()">reset all</span>
        </div>

        <div class="filter-section">
          <div v-for="(filter, index) in filter_list" :key="index">
            <div
              class="filter-toggle-content"
              :class="{
                'active-menu-bgColor': active_index_title == filter.title,
              }"
            >
              <div class="filter-title" @click="showSubMenues(filter.title)">
                {{ filter.title }}
                <i v-if="active_index_title == filter.title" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>

              <div v-if="active_index_title == filter.title">
                <div v-for="(filter, index1) in filter.filter" :key="index1">
                  <el-checkbox-group v-model="checked_filters" @change="applyFilter()">
                    <el-checkbox class="filter-tab" :label="filter"></el-checkbox>
                  </el-checkbox-group>
                </div>

                <!-- sector dropdown section -->
                <div v-if="filter.title == 'Sectors'">
                  <el-select class="top-margin-10 width-100" v-model="sector" size="small" collapse-tags clearable filterable @change="selectSector(sector)" placeholder="Select Sector">
                    <el-option v-for="item in sectorList" :key="item.sector" :label="item.sector" :value="item.sector" class="dropdown-ellipsis"></el-option>
                  </el-select>
                </div>

                <!-- market expert dropdown section -->
                <div v-if="filter.title == 'Market Participants'">
                  <div class="flex top-margin-10">
                    <el-select v-model="search_expert" filterable remote reserve-keyword placeholder="Search Expert E.g. Motilal Os" size="small" clearable :loading="is_search_expert_loading" :remote-method="searchExpertList" @change="handleExpert(search_expert)" @clear="clearExpertSelection">
                      <el-option v-for="expert in searched_expert_list" :key="expert.id" :label="expert.full_name" :value="expert.id"></el-option>
                    </el-select>
                  </div>
                  <div v-for="(filter, index1) in filter.experts" :key="index1">
                    <el-checkbox-group v-model="checked_profession_filters" @change="applyProfessionFilter()">
                      <el-checkbox class="filter-tab" :label="filter"></el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>

                <div v-if="filter.title == 'Target period'">
                  <el-select class="top-margin-10 width-100" v-model="target_period_type" size="small" filterable placeholder="Select" @change="selecteTargetPeriod()">
                    <el-option v-for="item in target_period_type_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>

                  <div v-if="target_period_type == 'shortTerm'">
                    <div>
                      <el-checkbox class="filter-tab" v-model="week_check" @change="setActivePeriodBtn('Week')">Week</el-checkbox>
                    </div>

                    <div>
                      <el-checkbox class="filter-tab" v-model="month_check" @change="setActivePeriodBtn('Month')">Month</el-checkbox>
                    </div>
                  </div>
                  <div v-if="target_period_type == 'midTerm'">
                    <div>
                      <el-checkbox class="filter-tab" v-model="current_quarter" @change="setActivePeriodBtn('Quarter')">Quarter</el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- <div class="mobile-filter-icon-section" v-if="isPremiumUser">
        <img src="../assets/images/company/filter_icon.svg" title="Filter" class="mobile-filter-icon"
          @click="openFilterDialog()" />
      </div> -->
    </div>
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig';
import { EventBus } from '../eventBus';
import { HelperNetworkCallBack } from '../mixins/Helper';

export default {
  name: 'MobileFilterDialog',

  mixins: [HelperNetworkCallBack],

  props: ['filter_list', 'filter_title', 'user_type'],

  data() {
    return {
      filter_dialog_visible: false,
      checked_filters: [],
      checked_expert_filters: [],
      checked_profession_filters: [],
      filter_obj: {
        filters: [],
        sector: '',
        expert_id_list: [],
        company_id_list: [],
        profession_list: [],
        target_period: {},
        category_stamp: [],
      },
      sector: '',
      sectorList: [],
      marketExpertList: [],
      active_index_title: 0,
      // for search expert
      search_expert: '',
      searched_expert_list: [],
      is_search_expert_loading: false,
      target_period_type: '',
      target_period_type_list: [
        {
          label: 'Intraday',
          value: 'IntraDay',
        },
        {
          label: 'Short Term',
          value: 'shortTerm',
        },
        {
          label: 'Mid Term',
          value: 'midTerm',
        },
        {
          label: 'Long Term',
          value: 'longTerm',
        },
      ],
      week_check: false,
      month_check: false,
      quarter_check: false,
      current_quarter: false,
      next_quarter: false,
      currentUrl: '',
      websiteUserType: {},
      appliedFilters: [],
    };
  },

  mounted() {
    this.currentUrl = localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href;

    // select user type for navigation access
    if (localStorage.getItem('websiteUserType')) {
      this.websiteUserType = JSON.parse(localStorage.getItem('websiteUserType'));
    }

    this.getSectorList();

    //emitted event on stock select and cleared selected market expert
    EventBus.$on('selectedStock', (stock) => {
      this.search_expert = '';
    });

    EventBus.$on('openFilterDialog', this.openMobileFilterPopup);

    if (this.$route.path == '/experts-past-recommendations' || this.$route.path == '/experts-past-recommendations-v2') {
      this.addDefaultFilters();
    }
  },

  methods: {
    openMobileFilterPopup() {
      this.openFilterDialog();
    },

    //get market experts list
    getCategoryWiseExpertList() {
      serverAddr
        .get('/stockants_pro/category-wise-expert/', {
          duration: this.target_period_type == 'shortTerm' ? ['IntraDay', 'Week', 'Month', 'Quarter'] : this.target_period_type == 'longTerm' ? ['Long_term'] : ['IntraDay', 'Week', 'Month', 'Quarter', 'Long_term'],
          target_period: {},
        })
        .then((response) => {
          if (response.data.status) {
            response.data.data.forEach((element) => {
              this.$set(element, 'toggled', false); //created toggled key to toggle expert list
            });

            this.filter_list.forEach((e) => {
              if (this.websiteUserType.userType == 'broker') {
                if (e.title == 'Market Participants') {
                  var experstList = response.data.data;
                  e.experts = [];
                  for (let i = 0; i < experstList.length; i++) {
                    if (experstList[i].profession != 'company' && experstList[i].profession != 'Broker' && experstList[i].profession != 'Market Expert') {
                      e.experts.push(experstList[i]);
                    }
                  }
                } else {
                  e.experts = response.data.data;
                }
              }
            });
          } else {
            this.filter_list.forEach((e) => {
              if (e.title == 'Market Participants') {
                e.experts = [];
              }
            });
          }

          this.addDefaultFilters();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    addDefaultFilters() {
      if (this.websiteUserType.userType == 'broker') {
        // show selected experts for bigul and paytmMoney
        this.filter_list.forEach((e) => {
          if (e.title == 'Market Participants') {
            e.experts = ['Financial Advisor', 'Analyst'];
          }
        });
      }

      this.filter_obj.profession_list = ['Financial Advisor', 'Analyst'];
      this.checked_profession_filters = ['Financial Advisor', 'Analyst'];

      if (this.isPremiumUser) {
        this.filter_obj.filters = ['Live', 'Yet to live', 'Updated'];
        this.checked_filters = ['Live', 'Yet to live', 'Updated'];
      }

      if (this.$route.query) {
        if (this.$route.query.cap) {
          this.checked_filters.push(this.$route.query.cap);
          this.filter_obj.filters.push(this.$route.query.cap);
        } else if (this.$route.query.price_range) {
          this.filter_obj.cmp_range = this.$route.query.price_range;
        } else if (this.$route.query.mtf) {
          this.filter_obj.mtf_stock = this.$route.query.mtf;
        } else if (this.$route.query.top_potential) {
          this.filter_obj.top_potential = this.$route.query.top_potential;
        } else if (this.$route.query.stamp) {
          this.filter_obj.category_stamp.push(this.$route.query.stamp);
        }
      }

      EventBus.$emit('emitSelectedFilters', this.filter_obj);
    },

    selectExpert(expert, index) {
      if (expert.profession != 'company') {
        if (this.filter_obj.expert_id_list.indexOf(expert.data[index].id) == -1) {
          this.filter_obj.expert_id_list.push(expert.data[index].id);
        } else {
          let i = this.filter_obj.expert_id_list.indexOf(expert.data[index].id);
          this.filter_obj.expert_id_list.splice(i, 1);
        }
      } else if (expert.profession == 'company') {
        if (this.filter_obj.company_id_list.indexOf(expert.data[index].id) == -1) {
          this.filter_obj.company_id_list.push(expert.data[index].id);
        } else {
          let i = this.filter_obj.company_id_list.indexOf(expert.data[index].id);
          this.filter_obj.company_id_list.splice(i, 1);
        }
      }

      this.filter_dialog_visible = false;

      EventBus.$emit('emitSelectedFilters', this.filter_obj);
    },

    showSubMarketExperts(expert, parentIndex, childIndex) {
      if (expert.toggled) {
        expert.toggled = false;
      } else {
        expert.toggled = true;
      }
    },

    //api to get stocks by search stock string
    searchExpertList: _.debounce(function (query) {
      this.searched_expert_list = [];
      this.is_search_expert_loading = true; //enabled loader

      serverAddr
        .post('/recommendation/v1/search-expert', {
          // reco: this.target_period_type,
          search: query,
        })
        .then((response) => {
          if (response.data.status) {
            this.searched_expert_list = response.data.data;
          } else {
            this.searched_expert_list = [];
          }

          this.is_search_expert_loading = false; //disabled loader
        })
        .catch(function (error) {
          console.log('error');
          this.is_search_expert_loading = false; //disabled loader
        });
    }, 350),

    //select seached expert
    handleExpert(item) {
      if (item) {
        // Clear the list and add the newly selected expert
        this.filter_obj.expert_id_list = [item]; // Replace with the new expert object

        // Emit event after selecting the expert
        EventBus.$emit('emitSelectedFilters', this.filter_obj);
      }
    },

    clearExpertSelection() {
      this.search_expert = null;
      this.filter_obj.expert_id_list = [];
      EventBus.$emit('emitSelectedFilters', this.filter_obj);
    },
    showSubMenues(title) {
      if (this.active_index_title == '') {
        this.active_index_title = title;
      } else if (this.active_index_title == title) {
        // compared active_index_title & title, if its both same then closed active                                               menu & is not then open current title of submenus.
        this.active_index_title = '';
      } else {
        this.active_index_title = title;
      }
    },

    //api to get sector list
    getSectorList() {
      serverAddr
        .post('/recommendation/v1/sector', {
          reco: this.target_period_type,
          user_id: this.user_type == 'expert' ? null : this.userProfile.id,
        })
        .then((response) => {
          if (response.data.status) {
            this.sectorList = response.data.data;
          } else {
            this.sectorList = [];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mouseOver() {
      let body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'hidden';
    },

    mouseLeave() {
      let body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'auto';
    },

    selectSector(sector) {
      this.filter_obj.sector = sector;
      this.filter_obj.filters = this.checked_filters;
      EventBus.$emit('emitSelectedFilters', this.filter_obj);
      this.filter_dialog_visible = false;
    },

    applyFilter() {
      this.filter_obj.filters = this.checked_filters;
      EventBus.$emit('emitSelectedFilters', this.filter_obj);
      this.filter_dialog_visible = false;
    },
    applyProfessionFilter() {
      this.filter_obj.profession_list = this.checked_profession_filters;
      EventBus.$emit('emitSelectedFilters', this.filter_obj);
      this.filter_dialog_visible = false;
    },

    resetFilter() {
      // clear all applied filters
      this.checked_filters = [];
      this.checked_expert_filters = [];
      (this.checked_profession_filters = []), (this.sector = '');

      this.search_expert = '';

      this.target_period_type = '';

      this.week_check = false;
      this.month_check = false;
      this.quarter_check = false;
      this.current_quarter = false;

      this.filter_obj = {
        filters: [],
        expert_id_list: [],
        company_id_list: [],
        profession_list: [],
        sector: '',
        target_period: {},
      };

      EventBus.$emit('clearedSelectedFilter', this.filter_obj);
      // EventBus.$emit("emitSelectedFilters", this.filter_obj);
      this.filter_dialog_visible = false;
    },

    clearFields(title) {
      if (this.target_period_type == 'shortTerm') {
        this.filter_obj.target_period = {};
        this.filter_obj.target_period.key = title;
      } else {
        delete this.filter_obj.target_period.key;
        this.filter_obj.target_period = {};
      }

      EventBus.$emit('emitSelectedFilters', this.filter_obj);
      this.filter_dialog_visible = false;
    },

    setActivePeriodBtn: function (title) {
      if (title == 'Week') {
        this.week_check = true;
        this.month_check = false;
        this.quarter_check = false;
      } else if (title == 'Month') {
        this.month_check = true;
        this.week_check = false;
        this.quarter_check = false;
      } else if (title == 'Quarter') {
        this.quarter_check = true;
        this.month_check = false;
        this.week_check = false;
      } else {
        this.week_check = false;
        this.month_check = false;
        this.quarter_check = false;
      }

      this.filter_obj.target_period = {};

      this.filter_obj.target_period.key = title;
      EventBus.$emit('emitSelectedFilters', this.filter_obj);
      this.filter_dialog_visible = false;
    },

    selecteTargetPeriod() {
      if (this.target_period_type == 'IntraDay' || this.target_period_type == 'longTerm') {
        this.filter_obj.target_period.key = this.target_period_type == 'longTerm' ? 'Long_term' : this.target_period_type;
        EventBus.$emit('emitSelectedFilters', this.filter_obj); //to filter data by week, month, quarter only

        this.filter_dialog_visible = false;
      }

      this.week_check = false;
      this.month_check = false;
      this.quarter_check = false;
      this.current_quarter = false;
    },

    openFilterDialog() {
      this.filter_dialog_visible = true;
    },

    //close filter dialog
    handleClose(done) {
      this.filter_dialog_visible = false;
    },
  },

  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },

    isPremiumUser() {
      // Check if userProfile exists and plan is Premium
      const planDetails = this.subscribedPlanDetails;
      return this.userProfile && planDetails && planDetails.plan === 'Premium';
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

@media screen and (max-width: 880px) {
  .ellipsis {
    max-width: 100px;
  }
}

@media screen and (max-width: 600px) {
  .dropdown-ellipsis {
    max-width: 190px;
  }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.el-dialog__title {
  color: $secondary-theme-color;
  font-size: 1rem;
}

.MobileFilterDialog .el-dialog {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 10px 10px 0 0;
  background-color: $filter-section-background-color;
}

.MobileFilterDialog .filter-section {
  background-color: #f7f8fc;
}

.MobileFilterDialog .filter-section-title {
  display: flex;
  justify-content: space-around;
  font-weight: 500;
  padding: 25px 0;
}

.MobileFilterDialog .filter-header {
  padding-top: 20px;

  div {
    text-align: center;
    border-radius: 20px;
    border: 1px solid #000;
    font-size: 0.8rem;
    font-weight: 600;
    color: #000;
    padding: 5px 20px;
    width: fit-content;
    margin: 0 auto;
  }
}

.MobileFilterDialog .border-bottom:after {
  position: absolute;
  bottom: -30px;
  left: 13px;
  width: 22px;
  height: 2px;
  margin-bottom: 25px;
  content: '';
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-color: $primary-theme-color;
}

.filter-toggle-content {
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
}

.MobileFilterDialog .filter-title {
  font-size: 0.8rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  .el-icon-plus,
  .el-icon-minus {
    font-size: 0.5rem;
    font-weight: 600;
  }
}

.filter-tab {
  display: block;
  margin-top: 10px;
}

.MobileFilterDialog .active-menu-bgColor {
  background: $filter-section-background-color;
}

// search stock input css start
.MobileFilterDialog .search-input {
  width: 100%;
}

// filters input type css start
.MobileFilterDialog .el-input--small .el-input__inner {
  border-radius: 25px !important;
  background: transparent !important;
  border-color: #797979 !important;
  color: #797979;
}

.MobileFilterDialog .el-radio__label {
  color: black;
  font-size: 0.8rem;
  font-weight: 400;
}

.MobileFilterDialog .el-input__inner::placeholder {
  color: #89898a;
}

.MobileFilterDialog .el-select .el-input .el-select__caret {
  /* Internet Explorer */
  color: #89898a;
}

.MobileFilterDialog .el-checkbox__inner {
  background-color: #dcdfe6;
}

.MobileFilterDialog .el-checkbox__label {
  text-transform: capitalize;
  font-size: 13px;
  color: #000;
  font-weight: 400;
}

.MobileFilterDialog .range-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.MobileFilterDialog .range-dropdown small {
  width: 100px;
  text-align: right;
  margin-right: 10px;
}

.MobileFilterDialog .range-dropdown .el-input--mini .el-input__inner {
  border-radius: 5px !important;
  border-color: #797979;
  background: transparent;
}

@media screen and (max-width: 1283px) {
  .MobileFilterDialog .el-dialog {
    width: 90%;
  }

  .MobileFilterDialog .el-dialog__body {
    padding: 0px 20px 20px 20px;
  }
}
</style>
<style lang="scss">
.MobileFilterDialog .el-select--mini {
  width: 100% !important;
  margin: 0 10px;
}
</style>
